// Espelha `AuditoriaController.ValidarPeriodoBusca` no backend: busca textual
// (`q`) faz `dados::text ILIKE` sem índice, então só é aceita com período
// completo (De + Até) de até 90 dias — senão o endpoint devolve 400. Extraído
// pra decidir o `enabled` da query ANTES de disparar a request (evita o 400
// vazar como "erro genérico" pro usuário) e pra ser testável isoladamente —
// é exatamente o tipo de regra de borda que quebra em silêncio.

/**
 * `periodoInicio`/`periodoFim` no formato `YYYY-MM-DD` do `<input type="date">`.
 * Sem `q`, o período é livre (regra não se aplica). Espelha o `dias < 0 || dias > 90`
 * do backend — inclusive nas duas pontas (90 dias exatos passa, 91 não).
 */
export function periodoServeParaBusca(q: string, periodoInicio: string, periodoFim: string): boolean {
  if (!q.trim()) return true;
  if (!periodoInicio || !periodoFim) return false;

  const dias = diasEntre(periodoInicio, periodoFim);
  return dias >= 0 && dias <= 90;
}

function diasEntre(inicioIso: string, fimIso: string): number {
  const inicio = new Date(`${inicioIso}T00:00:00`);
  const fim = new Date(`${fimIso}T00:00:00`);
  return Math.round((fim.getTime() - inicio.getTime()) / 86_400_000);
}

/**
 * Janela padrão oferecida na dica de "ajustar período" — últimos 90 dias até
 * hoje (a mesma janela máxima aceita pela busca). `hoje` é parâmetro pra
 * testabilidade; produção sempre chama sem argumento.
 */
export function ultimos90DiasIso(hoje: Date = new Date()): { inicio: string; fim: string } {
  const fim = new Date(hoje);
  const inicio = new Date(hoje);
  inicio.setDate(inicio.getDate() - 90);
  return { inicio: toIsoDateLocal(inicio), fim: toIsoDateLocal(fim) };
}

/**
 * Formata `Date` como `YYYY-MM-DD` no calendário LOCAL — nunca `toISOString()`,
 * que projeta em UTC e troca o dia perto da virada (ex.: 22h em UTC-3 já é o
 * dia seguinte em UTC). Helper único pra qualquer "hoje"/"ontem" que alimente
 * um `<input type="date">` — os dois pontos deste módulo (`ultimos90DiasIso` e
 * o `isoOntem` da AbaEventos) tinham esse bug em paralelo antes deste extract.
 */
export function toIsoDateLocal(d: Date): string {
  const ano = d.getFullYear();
  const mes = String(d.getMonth() + 1).padStart(2, '0');
  const dia = String(d.getDate()).padStart(2, '0');
  return `${ano}-${mes}-${dia}`;
}
